/**
 * CLIENT-SIDE MIGRATION SCRIPT
 * Run this from the Admin Dashboard or Console
 */
import { getFirestore, collection, getDocs, updateDoc, doc, writeBatch } from "firebase/firestore";
import { app } from "../firebase-config.js";

const db = getFirestore(app);

const generateReferralCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = '';
    for (let i = 0; i < 6; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
};

export const migratePoints = async () => {
    console.log("🚀 Starting Migration: Points -> ActivityPoints...");
    const usersRef = collection(db, "users");
    const snapshot = await getDocs(usersRef);
    const total = snapshot.size;
    let processed = 0;

    const batchSize = 500;
    let batch = writeBatch(db);
    let batchCount = 0;

    for (const userDoc of snapshot.docs) {
        const data = userDoc.data();
        const updates = {};

        // 1. Migrate Points
        if (data.points !== undefined && data.activityPoints === undefined) {
            updates.activityPoints = data.points;
            updates.starPoints = 0; // Init Star Points
            updates.legacyPoints = data.points; // Keep backup
        }

        // 2. Generate Referral Code
        if (!data.referralCode) {
            updates.referralCode = generateReferralCode();
        }

        // 3. Init Stats
        if (!data.stats || !data.stats.referralCount) {
            updates['stats.referralCount'] = 0;
            updates['stats.pointsEarnedTotal'] = data.points || 0;
        }

        if (Object.keys(updates).length > 0) {
            const ref = doc(db, "users", userDoc.id);
            batch.update(ref, updates);
            batchCount++;
        }

        processed++;

        if (batchCount >= batchSize) {
            await batch.commit();
            batch = writeBatch(db);
            batchCount = 0;
            console.log(`Saved batch... (${processed}/${total})`);
        }
    }

    if (batchCount > 0) {
        await batch.commit();
    }

    console.log(`✅ Migration Complete. Processed ${processed} users.`);
};
